module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iRSuu"))).then(() => parcelRequire('d0iPb'));